<template>
  <section class="hero is-bold app-navbar animated">
    <div class="hero-head">
      <div class="container">
        <nav class="navbar">
          <div class="navbar-brand">
            <div v-bind:class="{ 'navbar-burger': true, 'burger': true, 'is-active': !showBurger }" v-on:click="$emit('toggleSidebar')">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="navbar-menu">
            <div class="navbar-end">
              <span class="navbar-item">
                <button class="button" v-on:click="logout">
                  <span class="icon"><i class="fa fa-lg fa-sign-out"></i></span>
                  <span>Log out</span>
                </button>
              </span>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: [ 'showBurger' ],

    methods: {
      logout: function (event) {
        if (event) event.preventDefault()

        this.$store.commit('LOGOUT')
        this.$store.commit('SET_AUTHENTICATED', false)

        window.localStorage.clear()
      }
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/variables';

  .app-navbar {
    background-color: rgba(255, 255, 255, 0.9);
    position: fixed;
    min-width: 100%;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
    z-index: 1024;

    .navbar-burger {
      margin-left: inherit;
    }

    .container {
      margin-right: 40px;
    }

    // .nav-right {
    //   align-items: stretch;
    //   align-items: stretch;
    //   flex: 1;
    //   justify-content: flex-end;
    //   overflow: hidden;
    //   overflow-x: auto;
    //   white-space: nowrap;
    // }
  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?06a8c80c